















import { Component, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import { CurrentModal } from 'types/modal';
import { debounce } from '@utils/dev';
import { getScreenSize } from '@utils/client';
import ToastContainer from '@components/layout/toast-container.vue';

/* eslint-disable @typescript-eslint/no-var-requires */
const appConfig = require('./app.config.json');
/* eslint-enable @typescript-eslint/no-var-requires */

@Component({
	metaInfo: {
		titleTemplate(title): string {
			return title ? `${title} | ${appConfig.title}` : appConfig.title;
		},
		meta: [
			{ charset: 'utf-8' },
			{ name: 'viewport', content: 'width=device-width, minimum-scale=1.0, maximum-scale=1.0' },
			{ name: 'twitter:site', content: '@fundrise' },
			{ name: 'apple-mobile-web-app-capable', content: 'yes' },
			{ name: 'p:domain_verify', content: '411182b397074a11ab6dd421b34bc4e8' }
		]
	},
	components: {
		ToastContainer
	}
})
export default class App extends Vue {
	get currentModal(): CurrentModal | null {
		document.body.style.overflow = app.currentModal ? 'hidden' : '';
		return app.currentModal;
	}

	get routeKey(): string {
		const fullPath = this.$route.fullPath;
		const hashIndex = fullPath.indexOf('#');
		const queryIndex = fullPath.indexOf('?');
		if (hashIndex > -1) {
			if (queryIndex > hashIndex) {
				return fullPath.substring(0, hashIndex) + fullPath.substring(queryIndex, fullPath.length);
			}
			return fullPath.substring(0, hashIndex);
		}
		return fullPath;
	}

	updateScreenSize(): void {
		app.UPDATE_SCREEN_SIZE(getScreenSize());
	}

	destroyed(): void {
		window.removeEventListener('resize', debounce(this.updateScreenSize, 200));
	}

	async created(): Promise<void> {
		this.updateScreenSize();
		window.addEventListener('load', debounce(this.updateScreenSize, 200));
		window.addEventListener('resize', debounce(this.updateScreenSize, 200));
	}

	mounted(): void {
		this.$nextTick(() => {
			if (this.$route.hash) {
				const elementToScrollTo = document.querySelector(this.$route.hash);
				elementToScrollTo && elementToScrollTo.scrollIntoView();
			}
		});
	}

	public closeModal(): void {
		app.UPDATE_CURRENT_MODAL(null);
	}
}
